export type CreateConversionRatioApiResponse = /** status 201  */ ConversionRatioResponseBody;
export type CreateConversionRatioApiArg = {
  conversionTableId: string;

  createConversionRatioRequestBody: CreateConversionRatioRequestBody;
};
export type CreateConversionTableApiResponse = /** status 201  */ ConversionTableResponseBody;
export type CreateConversionTableApiArg = {
  createConversionTableRequestBody: CreateConversionTableRequestBody;
};
export type FindConversionTablesApiResponse = /** status 200  */ ConversionTableResponseBody[];
export type FindConversionTablesApiArg = {
  domesticCurrency: string;
  foreignCurrency: string;
};
export type GetConversionRatioApiResponse = /** status 200  */ ConversionRatioResponseBody;
export type GetConversionRatioApiArg = {
  conversionTableId: string;
  conversionRatioId: string;
};
export type RemoveConversionRatioApiResponse = unknown;
export type RemoveConversionRatioApiArg = {
  conversionTableId: string;
  conversionRatioId: string;
};
export type UpdateConversionRatioApiResponse = unknown;
export type UpdateConversionRatioApiArg = {
  conversionTableId: string;
  conversionRatioId: string;

  updateConversionRatioRequestBody: UpdateConversionRatioRequestBody;
};
export type GetConversionTableApiResponse = /** status 200  */ ConversionTableResponseBody;
export type GetConversionTableApiArg = {
  conversionTableId: string;
};
export type RemoveConversionTableApiResponse = unknown;
export type RemoveConversionTableApiArg = {
  conversionTableId: string;
};
export type ConversionRatioResponseBody = {
  id: string;
  ratio: string;
  amount: 1 | 10 | 100 | 1000;
  validFrom: string;
};
export type CreateConversionRatioRequestBody = {
  ratio: string;
  amount: 1 | 10 | 100 | 1000;
  validFrom: string;
};
export type ConversionTableResponseBody = {
  id: string;
  type: string | null;
  domesticCurrency: string;
  foreignCurrency: string;
  ratios: ConversionRatioResponseBody[];
};
export type CreateConversionTableRequestBody = {
  domesticCurrency: string;
  foreignCurrency: string;
};
export type UpdateConversionRatioRequestBody = {
  ratio: string;
  amount: 1 | 10 | 100 | 1000;
  validFrom: string;
};
export type FindConversionRatiosApiResponse = /** status 200  */ ConversionRatioResponseBody[];
export type FindConversionRatiosApiArg = {
  domesticCurrency: string;
  foreignCurrency: string;
  type?: string | null;
  validOn?: string | null;
};
export type FindConversionRateApiResponse = /** status 200  */ ConversionRateResponseBody;
export type ConversionRateResponseBody = {
  id: string;
  domesticCurrency: string;
  foreignCurrency: string;
  rateSource: string;
  ratio: string;
  amount: 1 | 10 | 100 | 1000 | 10000 | 100000 | 1000000;
  validFrom: string;
};
export type FindConversionRateApiArg = {
  domesticCurrency: string;
  foreignCurrency: string;
  validOn?: string | null;
};
